<template>
  <div class="tw-relative">
    <!-- Popover-based Boolean Select -->
    <div class="tw-relative">
      <Popover v-model:open="isOpen">
        <PopoverTrigger as-child>
          <input
            :aria-expanded="isOpen"
            class="tw-w-full tw-font-normal tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-secondary-300 tw-focus:border-secondary-300 tw-transition-colors tw-cursor-pointer tw-text-left"
            :class="
              props.header.column.getFilterValue() ? 'tw-text-secondary-500' : 'tw-text-gray-400'
            "
            :value="getDisplayValue()"
            readonly
            @click.stop
          />
        </PopoverTrigger>
        <PopoverContent
          class="tw-w-full tw-min-w-64 !tw-p-0 tw-z-[200] !tw-border-none !tw-shadow-[0px_0px_19px_0px_#f5f5f5]"
          align="start"
          @click.stop
        >
          <div class="tw-p-2">
            <div
              @click.stop="setFilterValue(undefined)"
              class="tw-flex tw-items-center tw-space-x-2 tw-px-2 tw-py-2 tw-text-sm hover:tw-bg-gray-100 tw-cursor-pointer tw-rounded-md tw-transition-colors"
            >
              <span class="tw-flex-1 tw-font-medium">{{ t('common.titles.all') }}</span>
            </div>
            <div
              @click.stop="setFilterValue('true')"
              class="tw-flex tw-items-center tw-space-x-2 tw-px-2 tw-py-2 tw-text-sm hover:tw-bg-gray-100 tw-cursor-pointer tw-rounded-md tw-transition-colors"
            >
              <span class="tw-flex-1 tw-font-medium">{{ t('common.titles.yes') }}</span>
            </div>
            <div
              @click.stop="setFilterValue('false')"
              class="tw-flex tw-items-center tw-space-x-2 tw-px-2 tw-py-2 tw-text-sm hover:tw-bg-gray-100 tw-cursor-pointer tw-rounded-md tw-transition-colors"
            >
              <span class="tw-flex-1 tw-font-medium">{{ t('common.titles.no') }}</span>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Header } from '@tanstack/vue-table';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const { t } = useI18n();

const props = defineProps<{
  header: Header<any, any>;
}>();

const emit = defineEmits<{
  'update:filter': [value: any];
}>();

// Track popover state
const isOpen = ref(false);

const setFilterValue = (value: string | undefined) => {
  // Convert string to actual boolean or undefined
  let booleanValue: boolean | undefined;
  if (value === 'true') {
    booleanValue = true;
  } else if (value === 'false') {
    booleanValue = false;
  } else {
    booleanValue = undefined;
  }

  // Emit the update:filter event with actual boolean value
  emit('update:filter', booleanValue);
  isOpen.value = false; // Close popover after selection
};

const getDisplayValue = () => {
  const currentValue = props.header.column.getFilterValue();

  if (currentValue === true || currentValue === 'true') {
    return t('common.titles.yes');
  } else if (currentValue === false || currentValue === 'false') {
    return t('common.titles.no');
  } else {
    return t('common.titles.all');
  }
};
</script>
